const TEMPORARY_AUTH_STATUSES = new Set([408, 425, 429]);

class TemporaryAuthError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TemporaryAuthError';
  }
}

function isTemporaryAuthStatus(status: number): boolean {
  return TEMPORARY_AUTH_STATUSES.has(status) || status >= 500;
}

function isTemporaryAuthError(error: unknown): error is TemporaryAuthError {
  return error instanceof TemporaryAuthError;
}

export {
  isTemporaryAuthError,
  isTemporaryAuthStatus,
  TemporaryAuthError,
};
